<template>
    <div id="m1_Easy" :style="{ 'height': inputBoxHeight }">
        <div class="content-wrapper">
            <div class="easy_messages_child" v-for="message in getMessageswithoutBlocked" :key="message.id">

                <div v-if="message.senderId == 0"></div>
                <div v-else class="m1_Easy_Message">

                    <Avatar :label="message.senderNickname.charAt(0).toUpperCase()"
                        style="background-color:#2196F3; color: #ffffff" shape="circle" class="m1_Easy_avatar"
                        v-if="!message.senderAvatar" />
                    <Avatar :image="$utils.getAvatar(message.senderAvatar)" shape="circle" class="m1_Easy_avatar"
                        v-else />
                    <div class="msg_container_Easy">
                        <span class="p0s"><svg viewBox="0 0 8 13" height="13" width="8"
                                preserveAspectRatio="xMidYMid meet" class="" version="1.1" x="0px" y="0px"
                                enable-background="new 0 0 8 13">
                                <path opacity="0.13"
                                    d="M1.533,3.568L8,12.193V1H2.812 C1.042,1,0.474,2.156,1.533,3.568z">
                                </path>
                                <path d="M1.533,2.568L8,11.193V0L2.812,0C1.042,0,0.474,1.156,1.533,2.568z"></path>
                            </svg></span>
                        <div class="msg_sender_Easy" @click="openPopupMenu($event, message)">
                            <span class="sender">{{ message.senderNickname }} </span>
                            <span class="mst_timestamp_Easy" v-if="settings.timestamp">{{
                                $utils.formatDateString(message.created_at || message.timestamp) }}</span>
                        </div>
                        <component :is="getMessageComponent(message.type)" :url="message.url"
                            v-if="message.type && message.type !== 'text'" class="m-2" />
                        <div class="msg_message_Easy" v-html="processMessage(message.message)"></div>


                        <i class="pi pi-ellipsis-v popup_buton" @click="toggle($event, message)"></i>


                    </div>
                </div>
            </div>
        </div>
        <Menu ref="menu" id="overlay_menu" :model="menuItems" :popup="true" />
        <Menu ref="menuNickname" id="overlay_menu_for_nickname" :model="getPopupMenuItems" :popup="true" />
        <BanDialog  :userData="selectedNickname" ref="banDialog" :channel="selectedChannel" />

    </div>
</template>

<script>
import { EmojiIndex } from "emoji-mart-vue-fast/src";
import data from "emoji-mart-vue-fast/data/all.json";

import BanDialog from '../dialogs/BanDialog.vue';


import AudioComponent from './messageTypes/AudioComponent.vue'
import VideoComponent from './messageTypes/VideoComponent.vue'
import ImageComponent from './messageTypes/ImageComponent.vue'
import FileComponent from './messageTypes/FileComponent.vue'


let emojiIndex = new EmojiIndex(data);

export default {
    props: ['messages', 'chatType', 'blocks', 'conversation_id', 'settings', 'my_profile', 'user_access'],
    components: {
        AudioComponent,
        VideoComponent,
        ImageComponent,
        FileComponent,
        BanDialog
    },


    data() {
        return {
            selectedChannel: null,
            emojiIndex: emojiIndex,
            inputBoxHeight: 0,
            menuItems: [
                {
                    label: this.$t('delete'),
                    icon: 'pi pi-times',
                    command: () => {
                        console.log(this.selectedMessage);
                        this.$emit('selectMenu', { action: 'delete_message', message: { conversation_id: this.conversation_id, message_id: this.selectedMessage.id } });
                        this.$socket.emit('delete-message', { conversation_id: this.conversation_id, message_id: this.selectedMessage.id });
                    }
                },
                {
                    label: this.$t('dialogs.user_context_actions.block'),
                    icon: 'pi pi-user-minus',
                    command: () => {
                        this.$emit('selectMenu', { action: 'block', user: { user_id: this.selectedMessage.senderId } });
                    }
                },
                {
                    label: this.$t('report'),
                    icon: 'pi pi-bell',
                    command: () => {
                        this.$socket.emit('report-message', { conversation_id: this.conversation_id, message_id: this.selectedMessage.id });
                    }
                }
            ],
            selectedMessage: null,
            selectedNickname: null
        };
    },
    computed: {
        getMessageswithoutBlocked() {
            if (this.messages == null) return [];
            return this.messages.filter((message) => {
                return !this.blocks.find(c => c.target_id == message.senderId);
            })
        },
        getPopupMenuItems() {
            let defaultMenu = [
                {
                    label: this.selectedNickname ? this.selectedNickname.nickname : '',

                },
                {
                    label: this.$t('dialogs.user_context_actions.send_message'),
                    icon: 'pi pi-send',
                    command: () => {
                        this.$emit('selectMenu', { action: 'message', user: { user_id: this.selectedNickname.user_id, nickname: this.selectedNickname.nickname, avatar: this.selectedNickname.avatar } });
                    }
                },
                {
                    label: this.$t('dialogs.user_context_actions.showProfile'),
                    icon: 'pi pi-user-edit',
                    command: () => {
                        this.$emit('selectMenu', { action: 'showProfile', user: { user_id: this.selectedNickname.user_id, nickname: this.selectedNickname.nickname, avatar: this.selectedNickname.avatar } });
                    }
                },
                {
                    label: this.$t('dialogs.user_context_actions.sendGift'),
                    icon: 'pi pi-gift',
                    command: () => {
                        this.$emit('selectMenu', { action: 'gift', user: { user_id: this.selectedNickname.user_id, nickname: this.selectedNickname.nickname, avatar: this.selectedNickname.avatar } });
                    }
                },
            ];
            if (this.user_access > 10 || this.my_profile.access > 10) {
                defaultMenu.push({
                    label: this.$t('dialogs.user_context_actions.kick'),
                    icon: 'pi pi-hashtag',
                    command: () => {
                        this.selectedChannel = { id: this.conversation_id, name: 'Channel' };
                        this.$refs.banDialog.showDialog();

                    }
                });
            }
            if (this.my_profile.access > 50) {
                defaultMenu.push({
                    label: this.$t('dialogs.user_context_actions.kickServer'),
                    icon: 'pi pi-shield',
                    command: () => {
                        this.selectedChannel = null;
                        this.$refs.banDialog.showDialog();
                    }
                });
            }



            return defaultMenu;
        }
    },
    mounted() {
        this.scrollToBottom();
        window.selectMention = (element) => {
            if (element.getAttribute('user-id')) {
                this.$emit('select-mention', element.getAttribute('user-id'));
            }
        }
    },
    unmounted() {
        window.selectMention = null;
    },
    updated() {
        this.scrollToBottom();
    },
    watch: {
        messages() {
            this.$nextTick(this.scrollToBottom);
        }
    },
    methods: {
        getMessageComponent(type) {
            switch (type) {
                case 'audio':
                    return 'AudioComponent'
                case 'video':
                    return 'VideoComponent'
                case 'image':
                    return 'ImageComponent'
                case 'file':
                    return 'FileComponent'
                default:
                    return ''
            }
        },
        setHeight(height) {
            this.inputBoxHeight = (height - 12) + 'px';
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const container = document.querySelector('#m1_Easy');
                container.scrollTop = container.scrollHeight;
            });
        },
        processMessage(message) {
            message = message.replace(/⦅@([^,]+),(\d+)⦆/g, '<span class="mention" user-id="$2" onclick="window.selectMention(this)">@$1</span>');
            message = message.replace(/:([a-zA-Z0-9_+-]+):/g, (match, p1) => {
                const emoji = this.emojiIndex.findEmoji(p1);
                if (!emoji) return '';
                let style = `background-position: ${emoji.getPosition()}; background-image: url(https://unpkg.com/emoji-datasource-apple@15.0.1/img/apple/sheets-256/64.png); width: 16px; height: 16px; display: inline-block; background-size: 5700%`
                return `<span class='emoji' style="${style}"></span>`
            });

            return message;
        },
        toggle(event, message) {
            this.selectedMessage = message
            this.$refs.menu.toggle(event);
        },
        openPopupMenu(event, message) {
            console.log(message);
            this.selectedNickname = {
                user_id: message.senderId,
                nickname: message.senderNickname,
                avatar: message.senderAvatar
            }
            this.$refs.menuNickname.toggle(event);
        }
    }
};
</script>

<style>
#m1_Easy {
    flex-grow: 1;
    flex-shrink: 1;
    overflow-y: auto;
    scroll-behavior: smooth;
    height: calc(100% - 66px);
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow-y: auto;
    min-height: 100%;
}


#m1_Easy .m1_Easy_Message {
    display: flex;
    align-items: flex-start;
    margin-top: 3px;
    margin-bottom: 5px;
}

#m1_Easy .msg_container_Easy {
    padding-right: 30px;
    padding-left: 10px;
    margin-left: 10px;
    background-color: var(--p-neutral-0);
    position: relative;
    border-radius: 7.5px;
    border-top-left-radius: 0;
    box-shadow: rgba(11, 20, 26, 0.13);
}

#m1_Easy .msg_container_Easy .p0s svg path {
    fill: var(--p-neutral-0);
}

#m1_Easy .m1_Easy_avatar {
    margin-left: 4px;
    cursor: pointer;
}

.msg_sender_Easy {
    display: flex;
    align-items: center;
    gap: 50px;
    font-size: 12.8px;
    font-weight: 600;
    justify-content: space-between;
}

.msg_sender_Easy span.sender {
    cursor: pointer;
    font-size: 16px;
}

.msg_sender_Easy span.sender:hover {
    text-decoration: underline;
}

.msg_message_Easy {
    font-size: 1rem;
    font-weight: 400;
}

#m1_Easy .m1_Easy_Message .p0s {
    left: -8px;
    position: absolute;
    top: -2px;
    z-index: 100;
    display: block;
    width: 8px;
    height: 13px;
}

.mention {
    color: #0a6ed1;
}

.easy_messages_child:last-child {
    margin-bottom: 20px !important;
}



.popup_buton {
    position: absolute !important;
    right: 5px;
    top: 5px;
    display: none !important;
    cursor: pointer;
    padding: 5px;
}

.easy_messages_child:hover .popup_buton {
    display: block !important;
}
</style>
